import recipients from "@/store/app/salesforce/settings/recipients"

export default {
  namespaced: true,

  actions: {},

  modules: {
    recipients,
  }
}
